
const origin = (): string => {
    switch (window.location.hostname) {
        case 'localhost':
        case '127.0.0.1':
            return 'http://localhost:9330/api-public/v1';
        case '10.0.2.2': // Android Emulator
            return 'http://10.0.2.2:9330/api-public/v1';
        case 'track.ristovskigroup.com.au':
            return 'https://qa.subtrux-test.net/api-public/v1';
        case 'qa-track.subtrux-test.net':
            return 'https://qa.subtrux-test.net/api-public/v1';
        default:
            return 'https://app.subtrux.com/api-public/v1'
    }
}

const API_ORIGIN: string = origin();

const API = {
    origin,
    ORIGIN: API_ORIGIN,
    API_ORIGIN
}

export default API;

